<a aria-expanded="false" [matMenuTriggerFor]="userActions">
  <anon-user-photo [user]="authService.user"></anon-user-photo>
</a>
<mat-menu xPosition="before" #userActions="matMenu">
  <button mat-menu-item type="button" *ngFor="let userAction of menuService.userActions" [routerLink]="userAction.routerLink">
    <mat-icon class="material-icons-round">{{userAction.icon}}</mat-icon>{{userAction.name}}
  </button>
  <button mat-menu-item (click)="authService.logout()">
    <mat-icon class="material-icons-round">logout</mat-icon>Sign Out
  </button>
</mat-menu>
